import createReducer from 'Lib/createReducer';

import { RESET_ANNOTATION } from 'Reducers/compModels/annotation';

export const SAVE_DEFAULT_SELECTEDHIGHLIGHT = 'SAVE_DEFAULT_SELECTEDHIGHLIGHT';
export const SAVE_SELECTEDHIGHLIGHT = 'SAVE_SELECTEDHIGHLIGHT';


let initialState = {
  color: '',
  darkColor: '',
  id: '',
  label: '',
  markerId: '',
  noteText: ''
};

const actionHandlers = {
  [RESET_ANNOTATION]: (state, action) => {
    return { ...initialState };
  },

  [SAVE_DEFAULT_SELECTEDHIGHLIGHT]: (state, action) => {
    if (!initialState.markerId) {
      initialState = action.data;
    }

    return { ...initialState };
  },

  [SAVE_SELECTEDHIGHLIGHT]: (state, action) => {
    return { ...action.data };
  }
};


export default createReducer(initialState, actionHandlers);
